import { useSelector, useDispatch } from "react-redux";
import { bindActionCreators } from "redux";
import { RootState } from "../../../init/reduxInit";
import { panelSlice } from "./slice";
import { useMemo } from "react";

// Create selectors
const selectPanelLoading = (state: RootState) => state.panel.loading;
const selectPanelState = (state: RootState) => state.panel.state;

export const usePanel = () => {
    const dispatch = useDispatch();

    // Use specific selectors instead of selecting the entire state
    const loading = useSelector(selectPanelLoading);
    const state = useSelector(selectPanelState);

    // Memoize actions and thunks
    const actions = useMemo(
        () => bindActionCreators(panelSlice.actions, dispatch),
        [dispatch]
    );

    return {
        loading,
        state,
        actions,
    };
};
